<template>
  <div class="form-structure" v-html="$appSettings.SollicitationReason"></div>
</template>

<script>
// import Loader from './components/Loader.vue'
import Vue from "vue";

export default Vue.extend({
  name: "form-structure",

  components: {},

  data() {
    return {};
  },

  computed: {},

  methods: {},

  watch: {}
});
</script>

<style scoped></style>
